import React from 'react';

const RmbIcon = ({ size = 32, color = 'currentColor', ...props }) => (
  <svg t="1765178303967" fill='currentColor' class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2691" width={size} height={size}>
    <path d="M596.16 501.418667 853.333333 501.418667 853.333333 418.069333 645.290667 418.069333 804.970667 147.136 731.029333 105.536 512 477.141333 292.970667 105.536 219.029333 147.136 378.709333 418.069333 170.666667 418.069333 170.666667 501.418667 427.84 501.418667 469.333333 571.84 469.333333 626.453333 170.666667 626.453333 170.666667 709.802667 469.333333 709.802667 469.333333 918.186667 554.666667 918.186667 554.666667 709.802667 853.333333 709.802667 853.333333 626.453333 554.666667 626.453333 554.666667 571.84 596.16 501.418667Z" p-id="2692"></path>
  </svg>
);

export default RmbIcon;



